<script setup lang="ts">
import Badge from 'primevue/badge';

defineProps({
  title: {
    type: String,
    required: true
  },
  changes: {
    type: Number,
    required: true
  },
  errors: {
    type: Number,
    required: true
  }
});

</script>

<template>
    <div class="tab-root-header">
        <span class="font-bold white-space-nowrap">{{title}}</span>
        <Badge :value="changes + errors"
            v-if="changes > 0 || errors > 0"
            class="badge"
            :severity="errors > 0 ? 'danger' : 'warning'"/>
    </div>
</template>

<style lang="css" scoped>
.tab-root-header > span {
    font-weight: 600;
}
.badge {
    margin-left: 16px;
}
</style>
